import API from '../components/supercut/shared/utils/api'
import { CreationToolVideoInfo } from '../types'
import { getUrlMimeType } from './get-source-info'

const api = new API()

const getVideoInfo = (videoUrl: string, withCaption: boolean, quality = 'hd'): Promise<CreationToolVideoInfo> =>
    new Promise(async (resolve, reject) => {
        const mimeType = getUrlMimeType(videoUrl)

        // youtube/vimeo
        if (mimeType === 'youtube' || mimeType === 'vimeo') {
            try {
                const {
                    duration,
                    privacy,
                    title,
                    width,
                    height,
                    has_captions = false,
                    languages,
                } = await api.getVideoEmbedInfo(
                    videoUrl, // .replace(/(^\w+:|^)\/\//, '')
                    withCaption,
                    quality
                )
                resolve({
                    duration,
                    width,
                    height,
                    title,
                    isPrivate: privacy && !privacy.download,
                    hasCaptions: has_captions,
                    languages,
                })
            } catch (err) {
                reject(err)
            }
        }

        const video = document.createElement('video')
        video.onloadedmetadata = () => {
            resolve({
                duration: video.duration,
                width: video.videoWidth,
                height: video.videoHeight,
            })
        }
        video.onerror = reject
        video.src = videoUrl
    })

export default getVideoInfo
